import Banner from "@/components/landing/homeEleven/Banner";
import Features from "@/components/landing/homeEleven/Features";
import GetStarted from "@/components/landing/homeEleven/GetStarted";
import Testimonials from "@/components/landing/homeSeven/Testimonials";

export default function HomeEleven() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Features section */}
      <Features />

      {/* Get Started section */}
      <GetStarted />

      {/* Testimonials section */}
      <Testimonials
        title="Freelancers rate the OracleMarket mobile experience"
        subtitle="Send invoices, track payouts, and approve transfers without touching a laptop."
      />
    </>
  );
}
